<template>
<div>
  <v-dialog v-model="userPermisionShow"
            width="1200px">
    <v-card>
      <v-container container--fluid>
        <v-row class="px-4">
          <h1>{{'Group Permissions ID ' + selectGroupId }}</h1>
          <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="show=false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-row>
        <v-row :justify="$vuetify.breakpoint.smAndDown ? 'center' : 'space-between'">
          <v-col cols="4" sm="4" md="2">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>
          <v-col cols="4" sm="4" md="2">
            <div style="display: flex; justify-content: center; align-items: center">
              <v-btn text @click="refresh" v-if="!isVisible">
                <v-icon color="cyan darken-2">refresh</v-icon>
              </v-btn>
              <div v-if="isVisible" class="load-3">
                <div class="line"></div>
                <div class="line"></div>
                <div class="line"></div>
              </div>
            </div>
          </v-col>
          <v-col cols="4" sm="4" md="2" class="text-center" v-if="$vuetify.breakpoint.mdAndUp">
          </v-col>
          <v-col cols="4" sm="4" md="2" class="text-center" v-if="$vuetify.breakpoint.mdAndUp">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn class="mx-2" fab dark color="blue lighten-1" @click="addUserDialog=true" v-on="on">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </template>
              <span>Add user in group Permission</span>
            </v-tooltip>
          </v-col>
        </v-row>

      </v-container>
      <v-data-table
        :search="search"
        :headers="headers"
        :items="renderedPermissionGroupUsers"
        :loading="loading"
      >
        <template v-slot:item="props">
          <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headers" :key="index">
              {{props.item[header.value]}}
            </td>
            <td v-else style="text-align: center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon color="blue" @click="removeUser(props.item)" v-on="on" class="pl-1">
                    edit
                  </v-icon>
                </template>
                <span>Remove or add region on user</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>

  <v-dialog v-model="addUserDialog" width="600px">
    <v-card>
      <v-card-title>
        <h2>Add User In Permission Group</h2>
        <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="addUserDialog=false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider color="#42a5f5"></v-divider>
      <v-card-text>
        <v-container>
          <v-row dense>
            <v-autocomplete
              label="Choose a user..."
              :items="renderedUsers"
              item-text="username"
              item-value="id"
              v-model="selectUser"
              prepend-icon="fas fa-user"
            ></v-autocomplete>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="blue-grey lighten-2" @click="addUserDialog=false">Cancel</v-btn>
        <v-btn text color="blue darken-1" @click="getRgionByUser">Next</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


  <v-dialog v-model="addRegionDialog" width="1000px">
    <v-card>
      <v-card-title>
        <h2>Add {{selectUserName}} On Region In Permission Group</h2>
        <v-btn icon style="position: absolute; right: 15px; top: 10px;" @click="addRegionDialog=false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider color="#42a5f5"></v-divider>
      <v-card-text :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
        <v-container container--fluid grid-list-md v-if="renderedRegions">
          <v-row justify="center">

            <v-col cols="12">
              <v-card>
                <v-list  scrollable style="height: 400px; overflow: scroll">
                  <v-list-item
                    v-for="(region, index) in renderedRegions"
                    :key="index"
                  >
                    <v-list-item-action>
                      <v-checkbox @change="addUserGroup(region)" v-model="region.in_group"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-title>{{region.name}}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text  @click="closeAddNewUser" >Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>



</div>
</template>

<script>
import axios from "axios";

export default {
  name: "AddUserPermissionGroup",
  props: {
    selectGroupId: Number,
    userPermisionShow:Boolean,

  },
  data(){
    return{
      newGoupPermissionDialog:false,
      search: null,
      reload: false,
      isVisible: false,
      timer: '',
      loading: false,
      valid:false,
      headers:[
        {text: 'User Name', value: 'username', align: 'center', sortable: true},
        {text: 'Client Name', value: 'client_name', align: 'center', sortable: true},
        {text: 'Email', value: 'email', align: 'center', sortable: true},
        {text: 'Actions', value: 'actions', align: 'center', sortable: false}
      ],
      selectUser:null,
      addUserDialog:false,
      addRegionDialog:false,
      selectUserName:null,
    }
  },
  mounted: function () {
    this.timer = setInterval(() => {
      this.reload = !this.reload;
    }, 300000)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods:{
    removeUser(item){
       this.selectUser = item.id;
       this.selectUserName = item.username
       this.addRegionDialog = true;
    },
    addUserGroup(item){
      let body = {};
      body = {
        user_id:this.selectUser,
        region:item.id
      };
      if(body.user_id === null || body.user_id === undefined || item.id === undefined){
        this.$store.commit('displaySnackbar', 'Please select user name');
        return false;
      }
      if(this.selectGroupId){

        if(item.in_group){ // Tick
          axios.post(process.env.API_URL + '/permissiongroups/'+ this.selectGroupId +
              '/users/'+  this.selectUser + '/regions/'+ item.id, body)
            .then((response) => {
              this.updateDataTable();
              this.$store.commit('displaySnackbar', 'add successful');
            })
            .catch((error) => {
              this.$store.commit('displaySnackbar', 'Error: ' + error.response ? error.response.data.error : error);
            });

        } else { // Untick
          axios.delete(process.env.API_URL + '/permissiongroups/'+ this.selectGroupId + '/users/'
            + this.selectUser + '/regions/' + item.id)
            .then((response) => {
              this.updateDataTable();
              this.$store.commit('displaySnackbar', 'remove successful');
            })
            .catch((error) => {
              this.$store.commit('displaySnackbar', 'ERROR: Delete failed');
            });

        }
      }
    },
    getRgionByUser(){
       this.addRegionDialog = true;
    },
    updateDataTable() {
      this.reload = !this.reload;
    },
    refresh() {
      setTimeout(() => this.isVisible = false, 1000);
      this.isVisible = true;
      this.reload = !this.reload;
    },
    closeAddNewUser(){
      this.addRegionDialog=false;
      this.addUserDialog = false;
    }
  },
  computed: {
    show: {
      get() {
        return this.userPermisionShow;
      },
      set(value) {
        if (!value) this.$emit('close');
      }
    },
    renderedPermissionGroupUsers() {
      if (this.permissionGroupUsers === null || this.permissionGroupUsers === undefined) {
        return [];
      } else {
        return this.permissionGroupUsers;
      }
    },
    renderedRegions() {
      if (this.permissionGroupUserRegions === null || this.permissionGroupUserRegions === undefined) {
        return [];
      } else {
        return this.permissionGroupUserRegions;
      }
    },
    renderedUsers() {
      if (this.users === null || this.users === undefined) {
        return [];
      } else {
        this.users.filter((user) => {
          user.username = user.username + ' (' + user.client_name + ')';
        });
        this.info = this.users;
        return this.users;
      }
    },
  },
  asyncComputed: {
    async permissionGroupUsers() {
      if(this.selectGroupId){
        if (this.reload || !this.reload) {
          this.loading = true;
          return await axios.get(process.env.API_URL + '/permissiongroups/'
            + this.selectGroupId + '/users')
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              return [];
            });
        }
      }
    },
    async permissionGroupUserRegions() {
      if(this.selectGroupId){
        if (this.reload || !this.reload) {
          this.loading = true;
          return await axios.get(process.env.API_URL + '/permissiongroups/'
            + this.selectGroupId + '/users/' + this.selectUser + '/regions')
            .then((response) => {
              if (response.status === 200) {
                this.loading = false;
                return response.data;
              } else {
                this.loading = false;
                return [];
              }
            })
            .catch((error) => {
              this.loading = false;
              return [];
            });
        }
      }
    },
    async users() {
      return await axios.get(process.env.API_URL + '/users')
        .then((response) => {
          if (response.status === 200) {
            this.loading = false;
            return response.data;
          } else {
            this.loading = false;
            return [];
          }
        })
        .catch((response) => {
          this.loading = false;
          return [];
        });
    },
  },
}
</script>

<style scoped>

>>>.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
  display: none!important;
}

.line {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 15px;
  background-color: #6754a8;
}

@keyframes loadingC {
0 {transform: translate(0,0);}
50% {transform: translate(0,15px);}
100% {transform: translate(0,0);}
}

.load-3 .line:nth-last-child(1) {animation: loadingC .6s .1s linear infinite;}
.load-3 .line:nth-last-child(2) {animation: loadingC .6s .2s linear infinite;}
.load-3 .line:nth-last-child(3) {animation: loadingC .6s .3s linear infinite;}


</style>



// WEBPACK FOOTER //
// src/components/util/PermissionManage/AddUserPermissionGroup.vue